import { HeaderPage } from '../../containers/HeaderPage/HeaderPage';
import { Box, Grid, Paper } from '@material-ui/core';
import { PageWrapper } from '../../containers/PageWrapper';
import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { RouteParams } from '../Permissions/Permission';
import { useHistory } from 'react-router-dom';
import useSWR from 'swr';
import { AuditQuestionType } from '../../types/AuditQuestionTypeApiResponse';
import { API_URL } from '../../apiTypes';
import { fetcher, postApi, putApi } from '../../apiUtils';
import { equalsZero } from 'ramda-extension';
import { AuditTypeForm } from '../../form/audit-type';
import { UserRoles } from '../../types/applicationUser.types';
import { ifElse } from 'ramda';
import { appPaths } from '../../paths';
import { AuditTypeLayoutApiResponse } from '../../types/AuditTypeLayoutApiResponse';
import { useAuthContext } from '../../contexts/AuthContext';
import { Loader } from '../../components/Loader/Loader';
import { NotificationManager } from 'react-notifications';
import { useTranslation } from '../../contexts/translationContext';

export const AuditTypeNewEdit = () => {
    const { t } = useTranslation();
    const editRoles = [UserRoles.Admin];
    const { id } = useParams<RouteParams>();

    const { isAccessibleByUserRoleAndAdminPrivilege } = useAuthContext();
    if (!isAccessibleByUserRoleAndAdminPrivilege) return <Loader />;
    const canEdit = isAccessibleByUserRoleAndAdminPrivilege(editRoles);

    const numericId = Number(id);
    const history = useHistory();

    const {
        data: auditTypeLayoutList,
        error: errorAuditTypeLayout,
        isValidating: isValidatingLayout,
    } = useSWR<AuditTypeLayoutApiResponse>(`${API_URL.AUDIT_TYPE_LAYOUT_LIST}`, fetcher);

    const { data, error, mutate, isValidating } = useSWR<AuditQuestionType>(
        `${API_URL.AUDIT_TYPE_ITEM}?id=${numericId}`,
        fetcher,
        {
            revalidateOnFocus: false,
            revalidateOnMount: false,
            revalidateOnReconnect: false,
        }
    );

    useEffect(() => {
        if (!equalsZero(numericId)) {
            mutate();
        }
    }, [numericId]);

    const submit = (values) =>
        ifElse(
            equalsZero,
            () =>
                postApi({
                    url: API_URL.AUDIT_TYPE_CREATE,
                    data: values,
                    callAfterSuccess: () => {
                        NotificationManager.success(t('Notify.item-created'));
                        history.push(`${appPaths.AUDIT_TYPE}`);
                    },
                }),
            () =>
                putApi({
                    url: API_URL.AUDIT_TYPE_UPDATE,
                    data: values,
                    callAfterSuccess: () => NotificationManager.success(t('Notify.item-updated')),
                })
        )(numericId);
    const goBackUrl = `${appPaths.AUDIT_TYPE}`;
    return (
        <PageWrapper
            loading={isValidating || isValidatingLayout}
            error={error || errorAuditTypeLayout}
        >
            <HeaderPage
                stepName={
                    numericId === 0
                        ? t('Master-data.audit-types.detail.main-headline-new')
                        : t('Master-data.audit-types.detail.main-headline-edit')
                }
                breadCrumbSteps={[
                    { name: t('Master-data.audit-types.detail.main-headline'), pathToCutCount: 1 },
                ]}
                noPaper
                noMb
            />
            <Grid item container xs={12} sm={12} md={6}>
                <Paper>
                    <Box p={3}>
                        <AuditTypeForm
                            onSubmit={submit}
                            data={data}
                            layoutList={auditTypeLayoutList}
                            userCanEdit={canEdit}
                            goBackUrl={goBackUrl}
                        />
                    </Box>
                </Paper>
            </Grid>
        </PageWrapper>
    );
};
